import { useContextHook } from "../../Context/ContextOPen";
import { partnersOfSuccessList } from "../../Context/Lists";
import { Container } from "../../components";
import { content } from "../../lang/useLang";

const Partners = () => {
  const { swiperIndex, direction } = useContextHook();

  return (
    <div
      className="min-h-screen bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-[#334155] relative overflow-hidden"
      style={{ direction }}
    >
      <br />
      {/* خلفية متحركة متناسقة */}
      <div className="absolute inset-0 overflow-hidden">
        {/* دوائر متحركة */}
        <div className="absolute top-1/4 -left-10 w-72 h-72 bg-slate-600/20 rounded-full blur-3xl animate-orbital-1"></div>
        <div className="absolute bottom-1/4 -right-10 w-96 h-96 bg-slate-500/15 rounded-full blur-3xl animate-orbital-2"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-80 h-80 bg-slate-400/10 rounded-full blur-3xl animate-pulse-glow"></div>

        {/* شبكة متحركة */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-slate-500/20 to-transparent animate-shimmer"></div>
        </div>

        {/* جسيمات نجوم */}
        <div className="absolute inset-0">
          {[...Array(25)].map((_, i) => (
            <div
              key={i}
              className="absolute w-1 h-1 bg-slate-300 rounded-full animate-twinkle"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 5}s`,
                animationDuration: `${3 + Math.random() * 4}s`,
              }}
            ></div>
          ))}
        </div>

        {/* خطوط متقاطعة */}
        <div className="absolute inset-0 opacity-15">
          <div className="absolute top-0 left-0 w-full h-0.5 bg-gradient-to-r from-transparent via-slate-400 to-transparent animate-scan-horizontal"></div>
          <div
            className="absolute top-1/3 left-0 w-full h-0.5 bg-gradient-to-r from-transparent via-slate-300 to-transparent animate-scan-horizontal"
            style={{ animationDelay: "1.5s" }}
          ></div>
          <div
            className="absolute top-2/3 left-0 w-full h-0.5 bg-gradient-to-r from-transparent via-slate-500 to-transparent animate-scan-horizontal"
            style={{ animationDelay: "3s" }}
          ></div>
        </div>
      </div>

      <Container className="relative z-10">
        <div className="min-h-screen flex items-center justify-center">
          <div className="w-full">
            {/* العنوان مع أنيميشن */}
            <div
              className={`text-center mb-10 transition-all duration-1000 ${
                swiperIndex === 4
                  ? "opacity-100 translate-y-0"
                  : "opacity-0 translate-y-10"
              }`}
            >
              <h1
                className="text-4xl md:text-5xl font-bold mb-6"
                style={{
                  background:
                    "linear-gradient(135deg, #cbd5e1 0%, #94a3b8 25%, #475569 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  backgroundClip: "text",
                }}
              >
                {content["partners_of_success"]}
              </h1>
              <div className="w-32 h-1.5 bg-gradient-to-r from-slate-400 to-slate-600 mx-auto rounded-full mb-6 shadow-lg shadow-slate-500/30"></div>
              <p className="text-slate-300 text-xl max-w-2xl mx-auto leading-relaxed">
                {content["desc_partners"]}
              </p>
            </div>

            {/* شبكة الشعارات مع أنيميشن - 6 في الصف */}
            <div
              className={`grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 transition-all duration-1000 ${
                swiperIndex === 4
                  ? "opacity-100 scale-100"
                  : "opacity-0 scale-90"
              }`}
              style={{ transitionDelay: "500ms" }}
            >
              {partnersOfSuccessList.map((logo, index) => (
                <div
                  key={index}
                  className="group relative"
                  style={{
                    animationDelay: `${index * 80 + 800}ms`,
                  }}
                >
                  {/* تأثير خلفي للبطاقة */}
                  <div className="absolute -inset-1 bg-gradient-to-r from-slate-600 to-slate-500 rounded-2xl blur opacity-0 group-hover:opacity-30 transition duration-500"></div>

                  {/* البطاقة الرئيسية */}
                  <div
                    className={`relative bg-gradient-to-br from-white/10 to-white/5 rounded-xl overflow-hidden border border-slate-500/30 backdrop-blur-xl shadow-lg hover:shadow-xl transition-all duration-500 group-hover:-translate-y-1 group-hover:scale-105 group-hover:border-slate-400/50 ${
                      swiperIndex === 4 ? "animate-fade-in-up" : ""
                    }`}
                  >
                    <div className="p-4">
                      <div className="relative">
                        {/* تأثير إشعاعي */}
                        <div className="absolute -inset-3 bg-gradient-to-r from-slate-600/10 to-slate-500/10 rounded-full blur-lg opacity-0 group-hover:opacity-100 transition-all duration-700"></div>

                        {/* الشعار */}
                        <img
                          src={logo}
                          alt="Partner"
                          className="relative w-full h-16 object-contain  invert opacity-80 group-hover:opacity-100 group-hover:scale-110 transition-all duration-500 z-10"
                        />

                        {/* تأثير فوق الشعار */}
                        <div className="absolute inset-0 bg-gradient-to-br from-slate-600/5 to-slate-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-lg"></div>
                      </div>
                    </div>

                    {/* نقاط زخرفية */}
                    <div className="absolute -top-1 -right-1 w-2 h-2 bg-slate-400 rounded-full animate-ping opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                    <div
                      className="absolute -bottom-1 -left-1 w-2 h-2 bg-slate-500 rounded-full animate-ping opacity-0 group-hover:opacity-100 transition-opacity duration-500"
                      style={{ animationDelay: "1s" }}
                    ></div>
                  </div>

                  {/* خط متحرك تحت البطاقة */}
                  <div className="absolute -bottom-1 left-1/2 transform -translate-x-1/2 w-0 h-0.5 bg-gradient-to-r from-slate-400 to-slate-600 group-hover:w-2/3 transition-all duration-500 rounded-full"></div>
                </div>
              ))}
            </div>

            {/* نص إضافي في الأسفل */}
            <div
              className={`text-center mt-10 transition-all duration-1000 ${
                swiperIndex === 4
                  ? "opacity-100 translate-y-0"
                  : "opacity-0 translate-y-10"
              }`}
              style={{ transitionDelay: "1200ms" }}
            >
              <p className="text-slate-400 text-lg max-w-3xl mx-auto leading-relaxed">
                {content["desc_partners2"]}
              </p>
            </div>
          </div>
        </div>
      </Container>

      {/* الأنيميشن المخصصة */}
      <style jsx>{`
        @keyframes fade-in-up {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        @keyframes orbital-1 {
          0%,
          100% {
            transform: translate(0, 0) rotate(0deg);
          }
          25% {
            transform: translate(50px, -30px) rotate(90deg);
          }
          50% {
            transform: translate(0, -60px) rotate(180deg);
          }
          75% {
            transform: translate(-50px, -30px) rotate(270deg);
          }
        }
        @keyframes orbital-2 {
          0%,
          100% {
            transform: translate(0, 0) rotate(0deg);
          }
          25% {
            transform: translate(-40px, 20px) rotate(-90deg);
          }
          50% {
            transform: translate(0, 40px) rotate(-180deg);
          }
          75% {
            transform: translate(40px, 20px) rotate(-270deg);
          }
        }
        @keyframes pulse-glow {
          0%,
          100% {
            opacity: 0.1;
            transform: scale(1);
          }
          50% {
            opacity: 0.2;
            transform: scale(1.1);
          }
        }
        @keyframes shimmer {
          0% {
            transform: translateX(-100%);
          }
          100% {
            transform: translateX(100%);
          }
        }
        @keyframes twinkle {
          0%,
          100% {
            opacity: 0.3;
            transform: scale(1);
          }
          50% {
            opacity: 1;
            transform: scale(1.2);
          }
        }
        @keyframes scan-horizontal {
          0% {
            transform: translateX(-100%);
          }
          100% {
            transform: translateX(100%);
          }
        }
        .animate-fade-in-up {
          animation: fade-in-up 0.8s ease-out forwards;
          opacity: 0;
        }
        .animate-orbital-1 {
          animation: orbital-1 20s ease-in-out infinite;
        }
        .animate-orbital-2 {
          animation: orbital-2 25s ease-in-out infinite;
        }
        .animate-pulse-glow {
          animation: pulse-glow 8s ease-in-out infinite;
        }
        .animate-shimmer {
          animation: shimmer 3s ease-in-out infinite;
        }
        .animate-twinkle {
          animation: twinkle 3s ease-in-out infinite;
        }
        .animate-scan-horizontal {
          animation: scan-horizontal 4s linear infinite;
        }
      `}</style>
    </div>
  );
};

export default Partners;
